export const classTypeOption = ["All", "Hybrid", "Virtual"];
